export { ActivateProductSidebar } from './components/activate-product-dialog/activate-product-sidebar';
